import { Button } from "@newsela/angelou";

import {
  withTrackEvent,
  objectTypes,
  actionNames,
  eventTypes,
} from "@newsela/snitch";
import { TopicsDataQASelector } from "../../Topics.constants";
import {
  cancelButtonCss,
  modalFooterCss,
  footerButtonsWrapper,
} from "./TaxonomyModalFooter.styles";

interface ITaxonomyModalFooter {
  onSubmit: () => void;
  onCancel: () => void;
}

const ButtonWithTrackEvent = withTrackEvent(
  Button,
) as React.ForwardRefExoticComponent<
  React.ComponentProps<typeof Button> & React.RefAttributes<HTMLButtonElement>
>;
const eventProperties = {
  objectType: objectTypes.user,
  actionName: actionNames.update,
  event_type: eventTypes.click,
  streamProperties: {
    component_type: "TaxonomyAddClassModalButton",
    description: "Update Selected taxonomy options",
  },
};
const eventPropertiesCancel = {
  objectType: objectTypes.user,
  actionName: actionNames.interact,
  event_type: eventTypes.click,
  streamProperties: {
    component_type: "TaxonomyAddClassModalButton",
    description: "Close taxonomy modal",
  },
};

export const TaxonomyModalFooter = ({
  onSubmit,
  onCancel,
}: ITaxonomyModalFooter) => {
  return (
    <div css={modalFooterCss}>
      <div css={footerButtonsWrapper}>
        <ButtonWithTrackEvent
          flavor="TERTIARY"
          {...eventPropertiesCancel}
          onClick={() => onCancel()}
          __cssFor={{ root: cancelButtonCss }}
          dataProps={{ "data-qa-selector": TopicsDataQASelector.CANCEL_MODAL }}
        >
          Cancel
        </ButtonWithTrackEvent>
        <ButtonWithTrackEvent
          {...eventProperties}
          flavor="PRIMARY"
          onClick={() => {
            onSubmit();
          }}
          dataProps={{ "data-qa-selector": TopicsDataQASelector.APPLY_MODAL }}
        >
          Apply filters
        </ButtonWithTrackEvent>
      </div>
    </div>
  );
};
